<template>
  <DataTable
    ref="DataTable"
    :data-model="'roles'"
    :items="roles"
    :loading="loading"
    @reloadData="reload()"
    :display-name-singular="$t('entities.Roles.Singular')"
    :display-name-plural="$t('entities.Roles.Plural')"
    :exclude-fields="['id', 'permissions']"
    :permission-name="'Roles'"
    :allow-create="false"
    :allow-delete="false" />
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      roles: [],
      loading: true
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.reload();
    }
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/roles', {
        params: {
          locale: this.$i18n.locale
        }
      }).then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.roles = res.data.result;
        } else {
          this.roles = [];
        }
        this.loading = false;
      }).catch((err) => Promise.reject(err)).finally(() => {
        this.$refs.DataTable.finishSpinner();
      });
    }
  }
};
</script>
<style scoped></style>
